import React, { useState } from "react";

import Button from "components/ui/Button";
import Modal from "components/ui/Modal";
import { showToast } from "components/ui/toast";
import axios from "utils/axios";

const AiCompliance = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [address, setAddress] = useState("");
  const [selectedType, setSelectedType] = useState("");

  const handleUnlock = async () => {
    if (!address.trim() || !selectedType) {
      return showToast("error", "Please enter an address and select a type.");
    }

    try {
      setLoading(true);
      const response = await axios.post(`/admin/unlock/ai-status`, {
        address: address,
        type: selectedType,
      });

      if (response.data.success) {
        showToast("success", response.data?.message);
        setIsModalOpen(false);
        setAddress("");
        setSelectedType("");
      } else {
        showToast("error", response.data?.message);
      }
    } catch (error) {
      console.error("Unlock Error:", error);
      showToast("error", "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mx-auto p-4 max-w-lg">
      <div className="flex justify-center">
        <Button onClick={() => setIsModalOpen(true)} className="black-button">
          AI Unlock
        </Button>
      </div>

      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title="AI Unlock"
        className="max-w-2xl"
      >
        {/* Type Select */}
        <div className="col-span-6 flex flex-col mb-6">
          <label className="form-label">Select Type</label>
          <select
            className="form-input border border-mediumgray"
            value={selectedType}
            onChange={(e) => setSelectedType(e.target.value)}
          >
            <option value="">-- Select Type --</option>
            <option value="AiCompliance">AI Compliance</option>
            <option value="AiSalesContract">AI Sales Contract</option>
          </select>
        </div>

        {/* Address Input */}
        <div className="col-span-6 flex flex-col mb-4">
          <label className="form-label">Property Address</label>
          <input
            type="text"
            className="form-input border border-mediumgray"
            placeholder="e.g. 43 Rona Street, Peakhurst"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
          />
        </div>

        {/* Unlock Button */}
        <div className="flex justify-center">
          <Button
            onClick={handleUnlock}
            disabled={loading}
            loading={loading}
            className="black-button text-white px-4 py-2 rounded-md"
          >
            Unlock
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default AiCompliance;
